import { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  es: {
    // Navigation
    nav: {
      home: 'Inicio',
      aboutUs: 'Sobre Nosotros',
      whoWeAre: 'Quiénes Somos',
      team: 'Equipo',
      escolaridad: 'Escolaridad',
      coursesLevels: 'Cursos y Niveles',
      methodology: 'Metodología',
      philosophy: 'Filosofía',
      whatWeOffer: 'Qué Ofrecemos',
      calendar: 'Calendario',
      pricing: 'Precios',
      blog: 'Blog',
      contact: 'Contacto',
      register: 'Inscríbete',
      login: 'Iniciar Sesión',
      logout: 'Cerrar Sesión',
      dashboard: 'Mi Panel',
    },
    // Hero
    hero: {
      tagline: 'De casa al mundo, tu español crece con confianza',
      subtitle: 'Clases virtuales de español para niños y jóvenes. Grupos reducidos, profesores nativos con más de 15 años de experiencia.',
      cta1: 'Inscríbete',
      cta2: 'Reserva una cita',
      whatsapp: 'WhatsApp',
    },
    // Sections
    sections: {
      methodology: 'Metodología',
      methodologyDesc: 'Seguimos el currículo oficial del Ministerio de Educación de España, adaptado para estudiantes internacionales.',
      philosophy: 'Filosofía',
      philosophyDesc: 'Creemos en el aprendizaje inmersivo y el arraigo cultural como pilares fundamentales del dominio del español.',
      whatWeOffer: 'Qué Ofrecemos',
      whatWeOfferDesc: 'Clases semanales de 50 minutos, 30 semanas al año, organizadas por edad y nivel.',
      calendar: 'Calendario 2025/2026',
      calendarDesc: '3 trimestres, una clase presencial por trimestre en Medford, MA para estudiantes locales.',
    },
    // Pricing
    pricing: {
      title: 'Precios',
      subtitle: 'Elige el plan que mejor se adapte a tus necesidades',
      earlyBird: 'Early Bird',
      earlyBirdPeriod: 'Inscripción del 1 de mayo al 1 de julio',
      normal: 'Normal',
      normalPeriod: 'Inscripción del 1 de julio al 1 de septiembre',
      trimestral: 'Trimestral',
      trimestralPeriod: 'Inscripción en cualquier momento del año',
      perYear: '/año',
      perTrimester: '/trimestre',
      annual: 'Pago único',
      installments: '2 cuotas (50% + 50%)',
      monthly: '10 mensualidades',
      trimestralSingle: 'Pago único de $620',
      trimestralNote: 'Sin compromiso anual. Inscríbete trimestre a trimestre.',
      trimestralTotal: '(total si completas el año: $1,860)',
      siblingDiscount: '20% de descuento para hermanos',
      enroll: 'Inscribirse',
      bestValue: 'Mejor precio',
      flexible: 'Flexible',
    },
    // Contact
    contact: {
      title: 'Contacto',
      subtitle: 'Estamos aquí para ayudarte',
      name: 'Nombre',
      email: 'Correo electrónico',
      phone: 'Teléfono',
      subject: 'Asunto',
      message: 'Mensaje',
      send: 'Enviar mensaje',
      success: 'Mensaje enviado correctamente',
      location: 'Medford, Massachusetts',
    },
    // Footer
    footer: {
      rights: 'Todos los derechos reservados',
      privacy: 'Política de Privacidad',
      terms: 'Términos de Uso',
      cookies: 'Política de Cookies',
    },
    // Auth
    auth: {
      login: 'Iniciar Sesión',
      register: 'Registrarse',
      email: 'Correo electrónico',
      password: 'Contraseña',
      confirmPassword: 'Confirmar contraseña',
      name: 'Nombre completo',
      forgotPassword: '¿Olvidaste tu contraseña?',
      noAccount: '¿No tienes cuenta?',
      hasAccount: '¿Ya tienes cuenta?',
      googleLogin: 'Continuar con Google',
      or: 'o',
    },
    // Enrollment
    enrollment: {
      title: 'Formulario de Inscripción',
      step1: 'Datos del Padre/Tutor',
      step2: 'Datos del Estudiante',
      step3: 'Selección de Curso',
      step4: 'Contrato de Matrícula',
      step5: 'Pago',
      parentName: 'Nombre completo',
      parentEmail: 'Correo electrónico',
      parentPhone: 'Teléfono',
      parentAddress: 'Dirección',
      studentName: 'Nombre del estudiante',
      studentDob: 'Fecha de nacimiento',
      studentGrade: 'Curso actual',
      spanishLevel: 'Nivel de español',
      selectCourse: 'Seleccionar curso',
      paymentOption: 'Plan de pago',
      fullPayment: 'Pago único (100%)',
      twoInstallments: '2 cuotas (50% + 50%)',
      monthlyPayment: '10 mensualidades',
      siblingDiscount: '¿Tienes otro hijo inscrito?',
      contractTitle: 'Contrato de Matrícula',
      contractAccept: 'He leído y acepto las condiciones de matrícula',
      signatureName: 'Nombre completo del firmante',
      signatureCanvas: 'Firma aquí',
      signatureClear: 'Borrar firma',
      next: 'Siguiente',
      back: 'Atrás',
      submit: 'Enviar inscripción',
      success: 'Inscripción enviada correctamente. Te contactaremos pronto.',
    },
    // Courses
    courses: {
      title: 'Cursos y Niveles',
      subtitle: 'Programa oficial del Ministerio de Educación de España',
      levels: 'Niveles',
      dele: 'Preparación DELE',
      deleDesc: 'Cursos especializados para la preparación de exámenes DELE de todos los niveles.',
    },
    // Common
    common: {
      loading: 'Cargando...',
      error: 'Ha ocurrido un error',
      save: 'Guardar',
      cancel: 'Cancelar',
      edit: 'Editar',
      delete: 'Eliminar',
      confirm: 'Confirmar',
      readMore: 'Leer más',
      viewAll: 'Ver todos',
    },
  },
  en: {
    // Navigation
    nav: {
      home: 'Home',
      aboutUs: 'About Us',
      whoWeAre: 'Who We Are',
      team: 'Team',
      escolaridad: 'Education',
      coursesLevels: 'Courses & Levels',
      methodology: 'Methodology',
      philosophy: 'Philosophy',
      whatWeOffer: 'What We Offer',
      calendar: 'Calendar',
      pricing: 'Pricing',
      blog: 'Blog',
      contact: 'Contact',
      register: 'Register',
      login: 'Login',
      logout: 'Logout',
      dashboard: 'Dashboard',
    },
    // Hero
    hero: {
      tagline: 'From home to the world, your Spanish grows with confidence',
      subtitle: 'Virtual Spanish classes for children and teens. Small groups, native teachers with 15+ years of experience.',
      cta1: 'Register',
      cta2: 'Book a call',
      whatsapp: 'WhatsApp',
    },
    // Sections
    sections: {
      methodology: 'Methodology',
      methodologyDesc: 'We follow the official curriculum of the Spanish Ministry of Education, adapted for international students.',
      philosophy: 'Philosophy',
      philosophyDesc: 'We believe in immersive learning and cultural roots as fundamental pillars of Spanish mastery.',
      whatWeOffer: 'What We Offer',
      whatWeOfferDesc: 'Weekly 50-minute classes, 30 weeks per year, organized by age and level.',
      calendar: 'Calendar 2025/2026',
      calendarDesc: '3 trimesters, one in-person class per trimester in Medford, MA for local students.',
    },
    // Pricing
    pricing: {
      title: 'Pricing',
      subtitle: 'Choose the plan that best fits your needs',
      earlyBird: 'Early Bird',
      earlyBirdPeriod: 'Enrollment from May 1 to July 1',
      normal: 'Normal',
      normalPeriod: 'Enrollment from July 1 to September 1',
      trimestral: 'Trimester',
      trimestralPeriod: 'Enroll anytime during the year',
      perYear: '/year',
      perTrimester: '/trimester',
      annual: 'Full payment',
      installments: '2 installments (50% + 50%)',
      monthly: '10 monthly installments',
      trimestralSingle: 'One-time payment of $620',
      trimestralNote: 'No annual commitment. Enroll one trimester at a time.',
      trimestralTotal: '(full year total: $1,860)',
      siblingDiscount: '20% sibling discount',
      enroll: 'Enroll Now',
      bestValue: 'Best value',
      flexible: 'Flexible',
    },
    // Contact
    contact: {
      title: 'Contact',
      subtitle: "We're here to help",
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      subject: 'Subject',
      message: 'Message',
      send: 'Send message',
      success: 'Message sent successfully',
      location: 'Medford, Massachusetts',
    },
    // Footer
    footer: {
      rights: 'All rights reserved',
      privacy: 'Privacy Policy',
      terms: 'Terms of Use',
      cookies: 'Cookie Policy',
    },
    // Auth
    auth: {
      login: 'Login',
      register: 'Register',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Confirm password',
      name: 'Full name',
      forgotPassword: 'Forgot your password?',
      noAccount: "Don't have an account?",
      hasAccount: 'Already have an account?',
      googleLogin: 'Continue with Google',
      or: 'or',
    },
    // Enrollment
    enrollment: {
      title: 'Enrollment Form',
      step1: 'Parent/Guardian Info',
      step2: 'Student Info',
      step3: 'Course Selection',
      step4: 'Enrollment Agreement',
      step5: 'Payment',
      parentName: 'Full name',
      parentEmail: 'Email',
      parentPhone: 'Phone',
      parentAddress: 'Address',
      studentName: 'Student name',
      studentDob: 'Date of birth',
      studentGrade: 'Current grade',
      spanishLevel: 'Spanish level',
      selectCourse: 'Select course',
      paymentOption: 'Payment plan',
      fullPayment: 'Full payment (100%)',
      twoInstallments: '2 installments (50% + 50%)',
      monthlyPayment: '10 monthly installments',
      siblingDiscount: 'Do you have another enrolled child?',
      contractTitle: 'Enrollment Agreement',
      contractAccept: 'I have read and accept the enrollment terms',
      signatureName: 'Full name of signer',
      signatureCanvas: 'Sign here',
      signatureClear: 'Clear signature',
      next: 'Next',
      back: 'Back',
      submit: 'Submit enrollment',
      success: 'Enrollment submitted successfully. We will contact you soon.',
    },
    // Courses
    courses: {
      title: 'Courses & Levels',
      subtitle: 'Official Spanish Ministry of Education curriculum',
      levels: 'Levels',
      dele: 'DELE Preparation',
      deleDesc: 'Specialized courses for DELE exam preparation at all levels.',
    },
    // Common
    common: {
      loading: 'Loading...',
      error: 'An error occurred',
      save: 'Save',
      cancel: 'Cancel',
      edit: 'Edit',
      delete: 'Delete',
      confirm: 'Confirm',
      readMore: 'Read more',
      viewAll: 'View all',
    },
  },
};

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState('es');

  useEffect(() => {
    const saved = localStorage.getItem('arce_language');
    if (saved && (saved === 'es' || saved === 'en')) {
      setLanguage(saved);
    }
  }, []);

  const toggleLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem('arce_language', lang);
  };

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
